/**
 * Flash messages.
 *
 * Server-rendered, so they are readable without JavaScript; this adds dismissal
 * and an auto-hide. Errors are never auto-hidden — a message someone needs to
 * act on must not disappear while they are reading it.
 */
const AUTO_DISMISS_MS = 6000;

export function initToasts(root = document) {
  const container = root.querySelector("[data-toasts]");
  if (!container) return;

  container.querySelectorAll("[data-toast]").forEach((toast) => {
    const dismiss = toast.querySelector("[data-toast-dismiss]");
    if (dismiss) {
      dismiss.addEventListener("click", () => toast.remove());
    }
    if (toast.dataset.toast !== "error") {
      setTimeout(() => toast.remove(), AUTO_DISMISS_MS);
    }
  });
}
